import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const resendCateringPaymentLink = async (orderId) => {
  try {
    const response = await apiClient.post(
      `${API_ENDPOINTS.RESEND_CATERING_PAYMENT_LINK}/${orderId}`,
      {}
    );
    return response;
  } catch (error) {
    console.error("Error resending catering payment link:", error);
    throw error;
  }
};
